import script from "./SyncOrderLimit.vue?vue&type=script&lang=ts&setup=true"
export * from "./SyncOrderLimit.vue?vue&type=script&lang=ts&setup=true"

import "./SyncOrderLimit.vue?vue&type=style&index=0&id=9fcb81a8&lang=scss"

const __exports__ = script;

export default __exports__